import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    status, // 'confirm', 'success', 'error'
    reward,
    userPoints
}) => {

    const backdropVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    const modalVariants = {
        hidden: { opacity: 0, y: 30, scale: 0.95 },
        visible: { opacity: 1, y: 0, scale: 1 },
        exit: { opacity: 0, y: 30, scale: 0.95 },
    };
    
    const copyToClipboard = (text) => {
        // A fallback for navigator.clipboard for iframe environments
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            alert('Redemption code copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
        document.body.removeChild(textArea);
    };

    const renderContent = () => {
        switch (status) {
            case 'confirm':
                return (
                    <>
                        <motion.div
                            className="text-7xl mb-4"
                            animate={{ rotate: [0, -10, 10, -10, 0] }}
                            transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
                        >
                            🤔
                        </motion.div>
                        <h2 className="text-2xl font-bold text-gray-800">Confirm Redemption</h2>
                        <p className="text-gray-600 my-4">
                            Redeem <span className="font-bold">{reward.description}</span> for <span className="font-bold">{reward.pointsCost} points</span>?
                        </p>
                        <div className="flex justify-center gap-4">
                            <button onClick={onClose} className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold">Cancel</button>
                            <button onClick={onConfirm} className="px-6 py-2 bg-black text-white rounded-lg font-semibold">Yes, Redeem</button>
                        </div>
                    </>
                );
            case 'success':
                const redemptionCode = `VOLUNGO-${Date.now()}`;
                return (
                    <>
                        <motion.div
                            className="text-7xl mb-4"
                            initial={{ scale: 0 }}
                            animate={{ scale: 1, rotate: 360 }}
                            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
                        >
                            😎
                        </motion.div>
                        <h2 className="text-2xl font-bold text-gray-800">Success!</h2>
                        <p className="text-gray-600 my-2">Your reward has been redeemed.</p>
                        <p className="text-gray-500 text-sm mb-4">Show this code to the partner:</p>
                        <div className="bg-gray-100 p-3 rounded-lg flex items-center justify-between">
                            <span className="font-mono text-lg">{redemptionCode}</span>
                            <button onClick={() => copyToClipboard(redemptionCode)} className="text-sm font-semibold">Copy</button>
                        </div>
                        <button onClick={onClose} className="mt-6 w-full py-3 bg-black text-white rounded-lg font-semibold">Done</button>
                    </>
                );
            case 'error':
                return (
                    <>
                        <motion.div
                            className="text-7xl mb-4"
                            animate={{ y: [0, -10, 0] }}
                            transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
                        >
                            😞
                        </motion.div>
                        <h2 className="text-2xl font-bold text-gray-800">Not Enough Points</h2>
                        <p className="text-gray-600 my-4">
                            You need <span className="font-bold">{reward.pointsCost} points</span> for this reward, but you only have <span className="font-bold">{userPoints}</span>.
                        </p>
                        <button onClick={onClose} className="w-full py-3 bg-black text-white rounded-lg font-semibold">Okay</button>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    variants={backdropVariants}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
                    onClick={onClose}
                >
                    <motion.div
                        variants={modalVariants}
                        className="bg-white rounded-2xl p-8 w-full max-w-sm text-center"
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                    >
                        {renderContent()}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ConfirmationModal;
